export default {
    ca: {
        imageSourceLink: 'Imatge original',
    },
    es: {
        imageSourceLink: 'Imagen original',
    },
    en: {
        imageSourceLink: 'Source image',
    },
};



// WEBPACK FOOTER //
// ./src/map-viewer/components/pin-modal/pin-modal-translations.js